import {
  getValueFromSessionStorage,
  removeValueFromSessionStorage,
  setSessionStorage
} from "@src/helpers/webStorage";

import {
  asosGlobalNamespace,
  siteChromeGlobalNamespace
} from "@src/template/constants";

const getSessionStorageKey = attributeName =>
  `${asosGlobalNamespace}.${siteChromeGlobalNamespace}.${attributeName}`;

const getBrowserTelemetryApi = () => window.newrelic;

export const noticeError = (error, customAttributes) => {
  const telemetry = !__SERVER__ && getBrowserTelemetryApi();

  if (telemetry?.noticeError && error) {
    if (customAttributes) {
      telemetry.noticeError(error, customAttributes);
    } else {
      telemetry.noticeError(error);
    }
  }
};

export const addPageAction = (name, customAttributes) => {
  const telemetry = getBrowserTelemetryApi();

  if (telemetry?.addPageAction && name) {
    if (customAttributes) {
      telemetry.addPageAction(name, customAttributes);
    } else {
      telemetry.addPageAction(name);
    }
  }
};

export const setCustomAttribute = (name, value) => {
  const telemetry = getBrowserTelemetryApi();

  if (telemetry?.setCustomAttribute && name) {
    telemetry.setCustomAttribute(name, value);
  }
};

export const setCustomAttributeOnNextRequest = (
  attributeName,
  attributeValue
) => {
  setSessionStorage(getSessionStorageKey(attributeName), attributeValue);
};

export const finishSettingCustomAttributeFromPreviousRequest =
  attributeName => {
    const sessionStorageKey = getSessionStorageKey(attributeName);

    const valueFromSessionStorage =
      getValueFromSessionStorage(sessionStorageKey);

    if (valueFromSessionStorage) {
      removeValueFromSessionStorage(sessionStorageKey);
      setCustomAttribute(attributeName, valueFromSessionStorage);
    } else {
      setCustomAttribute(attributeName, "false");
    }
  };
